export default __webpack_public_path__ + "b8f9a01bf44d5912c2641b5902e67b38.png";